// extracted by mini-css-extract-plugin
module.exports = {"theme":"#00c4b3"};